export enum REFERRALTYPE {
  ENROLLMENTKIT = 'ENROLLMENTKIT',
  EMAILREFERRAL = 'EMAILREFERRAL',
  ROADMAPKIT = 'ROADMAPKIT',
  PLANOPTIONS = 'PLANOPTIONS',
  LINKSHARING = 'LINKSHARING',
  PRODUCER_URL = 'PRODUCER_URL'
}

export const REFERRAL_TYPE_DISPLAY = {
  [REFERRALTYPE.ENROLLMENTKIT]: 'Enrollment Kit',
  [REFERRALTYPE.EMAILREFERRAL]: 'Quote Email',
  [REFERRALTYPE.ROADMAPKIT]: 'Roadmap',
  [REFERRALTYPE.PLANOPTIONS]: 'Plan Options',
  [REFERRALTYPE.LINKSHARING]: 'Referral Email',
  [REFERRALTYPE.PRODUCER_URL]: 'Producer URL'

}